import axios from 'axios';
const API_EAN_URL = 'https://locatestore.intellibrand.ai/product/:ean?limit=:limit';

const productsByEan = {
  '7896012878439': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_p_pratica.png', description: 'Prática - P - 20 fraldas descartáveis' },
  '7896012877456': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_p_jumbo.png', description: 'Jumbo - P - 34 fraldas descartáveis' },
  '7896012878446': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_m_pratica.png', description: 'Prática - M - 18 fraldas descartáveis' },
  '7896012800416': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_m_jumbo.png', description: 'Jumbo - M - 30 fraldas descartáveis' },
  '7896012800744': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_m_mega.png', description: 'Mega - M - 50 fraldas descartáveis' },
  '7896012878453': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_g_pratica.png', description: 'Prática - G - 16 fraldas descartáveis' },
  '7896012800423': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_g_jumbo.png', description: 'Jumbo - G - 26 fraldas descartáveis' },
  '7896012800751': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_g_mega.png', description: 'Mega - G - 44 fraldas descartáveis' },
  '7896012878460': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_xg_pratica.png', description: 'Prática - XG - 12 fraldas descartáveis' },
  '7896012800430': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_xg_jumbo.png', description: 'Jumbo - XG - 22 fraldas descartáveis' },
  '7896012800768': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_xg_mega.png', description: 'Mega - XG - 40 fraldas descartáveis' },
  '7896012878477': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_sxg_pratica.png', description: 'Prática - SXG - 10 fraldas descartáveis' },
  '7896012800447': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_sxg_jumbo.png', description: 'Jumbo - SXG - 16 fraldas descartáveis' },
  '7896012800782': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_sxg_mega.png', description: 'Mega - SXG - 30 fraldas descartáveis' },
  '7896012877586': { name: 'Proteção de Mãe', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_grandinhos.png', description: 'Grandinhos - 14 fraldas descartáveis' },
  '7896012877913': { name: 'Colo de Mãe', image: './assets/img/colo-de-mae/tamanhos/colodemae_p_jumbo.png', description: 'Jumbo - P - 28 fraldas descartáveis' },
  '7896012877920': { name: 'Colo de Mãe', image: './assets/img/colo-de-mae/tamanhos/colodemae_m_jumbo.png', description: 'Jumbo - M - 24 fraldas descartáveis' },
  '7896012877975': { name: 'Colo de Mãe', image: './assets/img/colo-de-mae/tamanhos/colodemae_m_mega.png', description: 'Mega - M - 48 fraldas descartáveis' },
  '7896012877937': { name: 'Colo de Mãe', image: './assets/img/colo-de-mae/tamanhos/colodemae_g_jumbo.png', description: 'Jumbo - G - 20 fraldas descartáveis' },
  '7896012877982': { name: 'Colo de Mãe', image: './assets/img/colo-de-mae/tamanhos/colodemae_g_mega.png', description: 'Mega - G - 40 fraldas descartáveis' },
  '7896012877944': { name: 'Colo de Mãe', image: './assets/img/colo-de-mae/tamanhos/colodemae_xg_jumbo.png', description: 'Jumbo - XG - 16 fraldas descartáveis' },
  '7896012877999': { name: 'Colo de Mãe', image: './assets/img/colo-de-mae/tamanhos/colodemae_xg_mega.png', description: 'Mega - XG - 34 fraldas descartáveis' },
  '7896012877951': { name: 'Colo de Mãe', image: './assets/img/colo-de-mae/tamanhos/colodemae_sxg_jumbo.png', description: 'Jumbo - SXG - 14 fraldas descartáveis' },
  '7896012877869': { name: 'Amor de Mãe', image: './assets/img/amor-de-mae/tamanhos/amordemae.png', description: 'Tamanho Único - 18 fraldas descartáveis' },
  // Toalhas Umedecidas
  '7896012877562': { name: 'Toalhas Umedecidas', image: './assets/img/toalhas-umedecidas/toalhas-umedecidas-camomila.png', description: 'Camomila - 50UN' },
  '7896012802410': { name: 'Toalhas Umedecidas', image: './assets/img/toalhas-umedecidas/toalhas-umedecidas-suave.png', description: 'Suave - 50UN' },
  '7896012878019': { name: 'Toalhas Umedecidas', image: './assets/img/toalhas-umedecidas/toalhas-umedecidas-suave.png', description: 'Suave - Leve 100 Pague 90' },
  // Creme prevenção assaduras
  '7896012877739': { name: 'Creme Prevenção Assaduras', image: './assets/img/pomada-antiassaduras/pomada-antiassaduras-case.png', description: 'Pomada - 40G' },
  // Talco
  '7896012800874': { name: 'Talco', image: './assets/img/talco/talco.png', description: '200ml' },
  // Sabonete Espuma
  '7896012800850': { name: 'Sabonete Espuma', image: './assets/img/sabonete-espuma/sabonete-espuma.png', description: '200ml' },
  // Sabonete Barras
  '7896094905658': { name: 'Sabonete Barras', image: './assets/img/sabonete-barras/sabonete-camomila-e-erva-cidreira.png', description: 'Camomila e Erva Cidreira - 80g' },
  '7896094905627': { name: 'Sabonete Barras', image: './assets/img/sabonete-barras/sabonete-glicerinado.png', description: 'Glicerinado - 80g' },
  '7896094905634': { name: 'Sabonete Barras', image: './assets/img/sabonete-barras/sabonete-locao-hidratante.png', description: 'Hidratante - 80g' },
  '7896094905665': { name: 'Sabonete Barras', image: './assets/img/sabonete-barras/sabonete-leite-e-mel.png', description: 'Leite e Mel - 80g' },
  '7896094905641': { name: 'Sabonete Barras', image: './assets/img/sabonete-barras/sabonete-oleo-de-amendoas.png', description: 'Óleo de Amêndoas - 80g' },
  // Shampoo
  '7896012877722': { name: 'Shampoo', image: './assets/img/shampoo/shampoo-suave.png', description: 'Suave - 200ml' },
  '7896012800669': { name: 'Shampoo', image: './assets/img/shampoo/shampoo-camomila.png', description: 'Camomila - 200ml' },
  // Condicionador
  '7896012877715': { name: 'Condicionador', image: './assets/img/condicionador/condicionador-suave.png', description: 'Suave - 200ml' },
  '7896012800706': { name: 'Condicionador', image: './assets/img/condicionador/condicionador-camomila.png', description: 'Camomila - 200ml' },
  // Água de Colônia
  '7896012800867': { name: 'Água de Colônia', image: './assets/img/agua-colonia/agua-colonia.png', description: '100ml' },
  // Spray Desembaraçante
  '7896012800713': { name: 'Spray Desembaraçante', image: './assets/img/spray-desembaracante/spray-desembaracante.png', description: '200ml' },
}

const modalData = {
  'protecao-de-mae': {
    title: 'Proteção <span>de Mãe</span>',
    options: [
      {
        label: 'Selecione um tamanho',
        options: [
          { label: '', value: '', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_p_pratica.png' },
        ]
      },
      {
        label: 'P - Pequeno',
        options: [
          { label: '20 Fraldas', value: '7896012878439', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_p_pratica.png' },
          { label: '34 Fraldas', value: '7896012877456', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_p_jumbo.png' },
        ]
      },
      {
        label: 'M - Médio',
        options: [
          { label: '18 Fraldas', value: '7896012878446', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_m_pratica.png' },
          { label: '30 Fraldas', value: '7896012800416', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_m_jumbo.png' },
          { label: '50 Fraldas', value: '7896012800744', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_m_mega.png' },
        ]
      },
      {
        label: 'G - Grande',
        options: [
          { label: '16 Fraldas', value: '7896012878453', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_g_pratica.png' },
          { label: '26 Fraldas', value: '7896012800423', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_g_jumbo.png' },
          { label: '44 Fraldas', value: '7896012800751', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_g_mega.png' },
        ]
      },
      {
        label: 'XG - Extra Grande',
        options: [
          { label: '12 Fraldas', value: '7896012878460', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_xg_pratica.png' },
          { label: '22 Fraldas', value: '7896012800430', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_xg_jumbo.png' },
          { label: '40 Fraldas', value: '7896012800768', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_xg_mega.png' },
        ]
      },
      {
        label: 'SXG - Super Extra Grande',
        options: [
          { label: '10 Fraldas', value: '7896012878477', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_sxg_pratica.png' },
          { label: '16 Fraldas', value: '7896012800447', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_sxg_jumbo.png' },
          { label: '30 Fraldas', value: '7896012800782', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_sxg_mega.png' },
        ]
      },
      {
        label: 'Grandinhos',
        options: [
          { label: '14 Fraldas', value: '7896012877586', image: './assets/img/protecao-de-mae/tamanhos/protecaodemae_grandinhos.png' },
        ]
      },
    ]
  },
  'colo-de-mae': {
    title: 'Colo <span>de Mãe</span>',
    options: [
      {
        label: 'Selecione um tamanho',
        value: '',
        options: [
          { label: '', value: '', image: './assets/img/colo-de-mae/tamanhos/colodemae_p_jumbo.png' },
        ]
      },
      {
        label: 'P - Pequeno',
        value: 'p',
        options: [
          { label: '28 Fraldas', value: '7896012877913', image: './assets/img/colo-de-mae/tamanhos/colodemae_p_jumbo.png' },
          // { label: '56 Fraldas', value: '7896012877968', image: './assets/img/colo-de-mae/tamanhos/colodemae_p_mega.png' },
        ]
      },
      {
        label: 'M - Médio',
        value: 'm',
        options: [
          { label: '24 Fraldas', value: '7896012877920', image: './assets/img/colo-de-mae/tamanhos/colodemae_m_jumbo.png' },
          { label: '48 Fraldas', value: '7896012877975', image: './assets/img/colo-de-mae/tamanhos/colodemae_m_mega.png' },
        ]
      },
      {
        label: 'G - Grande',
        value: 'g',
        options: [
          { label: '20 Fraldas', value: '7896012877937', image: './assets/img/colo-de-mae/tamanhos/colodemae_g_jumbo.png' },
          { label: '40 Fraldas', value: '7896012877982', image: './assets/img/colo-de-mae/tamanhos/colodemae_g_mega.png' },
        ]
      },
      {
        label: 'XG - Extra Grande',
        value: 'xg',
        options: [
          { label: '16 Fraldas', value: '7896012877944', image: './assets/img/colo-de-mae/tamanhos/colodemae_xg_jumbo.png' },
          { label: '34 Fraldas', value: '7896012877999', image: './assets/img/colo-de-mae/tamanhos/colodemae_xg_mega.png' },
        ]
      },
      {
        label: 'SXG - Super Extra Grande',
        value: 'sxg',
        options: [
          { label: '14 Fraldas', value: '7896012877951', image: './assets/img/colo-de-mae/tamanhos/colodemae_sxg_jumbo.png' },
          // { label: '30 Fraldas', value: '7896012878002', image: './assets/img/colo-de-mae/tamanhos/colodemae_sxg_mega.png' },
        ]
      },
    ]
  },
  'amor-de-mae': {
    title: '<span>Amor de Mãe</span>',
    options: [
      {
        label: 'Recém Nascido',
        options: [
          { label: 'Tamanho Único', value: '7896012877869', image: './assets/img/amor-de-mae/tamanhos/amordemae.png' },
        ]
      },
    ]
  },
  'toalhas-umedecidas': {
    title: 'Toalhas <span>Umedecidas</span>',
    label1: '',
    label2: 'Tamanho',
    options: [
      {
        label: 'Toalha Umedecida',
        options: [
          { label: 'Camomila - 50UN', value: '7896012877562', image: './assets/img/toalhas-umedecidas/toalhas-umedecidas-camomila.png' },
          { label: 'Suave - 50UN', value: '7896012802410', image: './assets/img/toalhas-umedecidas/toalhas-umedecidas-suave.png' },
          { label: 'Suave - Leve 100 Pague 90', value: '7896012878019', image: './assets/img/toalhas-umedecidas/toalhas-umedecidas-suave.png' },
        ]
      },
    ]
  },
  'creme-prevencao-assaduras': {
    title: 'Creme para <span>Prevenção de Assaduras</span>',
    label1: '',
    label2: 'Tamanho',
    options: [
      {
        label: 'Creme para Prevenção de Assaduras',
        options: [
          { label: 'Creme para Prevenção de Assaduras 40g', value: '7896012877739', image: './assets/img/pomada-antiassaduras/pomada-antiassaduras-case.png' },
        ]
      },
    ]
  },
  'talco': {
    title: '<span>Talco</span>',
    label1: '',
    label2: 'Tamanho',
    options: [
      {
        label: 'Talco',
        options: [
          { label: 'Talco PomPom 200ml', value: '7896012800874', image: './assets/img/talco/talco.png' },
        ]
      },
    ]
  },
  'sabonete-espuma': {
    title: 'Sabonete <span>Espuma</span>',
    label1: '',
    label2: 'Tamanho',
    options: [
      {
        label: 'Sabonete Espuma',
        options: [
          { label: 'Sabonete Espuma 200ml', value: '7896012800850', image: './assets/img/sabonete-espuma/sabonete-espuma.png' },
        ]
      },
    ]
  },
  'sabonete-barras': {
    title: '<span>Sabonete</span> Barras',
    className: 'modalcompra-sabonete-barras',
    label1: '',
    label2: 'Fragrância',
    options: [
      {
        label: 'Sabonete Barras',
        options: [
          { label: 'Selecione uma Fragrância', value: '', image: './assets/img/sabonete-barras/sabonete-barras.png' },
          { label: 'Camomila e Erva Cidreira - 80g', value: '7896094905658', image: './assets/img/sabonete-barras/sabonete-camomila-e-erva-cidreira.png' },
          { label: 'Glicerinado - 80g', value: '7896094905627', image: './assets/img/sabonete-barras/sabonete-glicerinado.png' },
          { label: 'Hidratante - 80g', value: '7896094905634', image: './assets/img/sabonete-barras/sabonete-locao-hidratante.png' },
          { label: 'Leite e Mel - 80g', value: '7896094905665', image: './assets/img/sabonete-barras/sabonete-leite-e-mel.png' },
          { label: 'Óleo de Amêndoas - 80g', value: '7896094905641', image: './assets/img/sabonete-barras/sabonete-oleo-de-amendoas.png' },
        ]
      },
    ]
  },
  'shampoo': {
    title: '<span>Shampoo</span>',
    className: 'modalcompra-shampoo',
    label1: '',
    label2: 'Fragrância',
    options: [
      {
        label: 'Shampoo',
        options: [
          { label: 'Selecione uma Fragrância', value: '', image: './assets/img/shampoo/shampoo.png' },
          { label: 'Suave 200ml', value: '7896012877722', image: './assets/img/shampoo/shampoo-suave.png' },
          { label: 'Camomila 200ml', value: '7896012800669', image: './assets/img/shampoo/shampoo-camomila.png' },
        ]
      },
    ]
  },
  'condicionador': {
    title: '<span>Condicionador</span>',
    className: 'modalcompra-condicionador',
    label1: '',
    label2: 'Fragrância',
    options: [
      {
        label: 'Condicionador',
        options: [
          { label: 'Selecione uma Fragrância', value: '', image: './assets/img/condicionador/condicionador.png' },
          { label: 'Suave 200ml', value: '7896012877715', image: './assets/img/condicionador/condicionador-suave.png' },
          { label: 'Camomila 200ml', value: '7896012800706', image: './assets/img/condicionador/condicionador-camomila.png' },
        ]
      },
    ]
  },
  'agua-colonia': {
    title: 'Água de <span>Colônia</span>',
    label1: '',
    label2: 'Tamanho',
    options: [
      {
        label: 'Água de Colônia',
        options: [
          { label: 'Água de Colônia 100ml', value: '7896012800867', image: './assets/img/agua-colonia/agua-colonia.png' },
        ]
      },
    ]
  },
  'spray-desembaracante': {
    title: 'Spray <span>Desembaraçante</span>',
    label1: '',
    label2: 'Tamanho',
    options: [
      {
        label: 'Spray Desembaraçante',
        options: [
          { label: 'Spray Desembaraçante 200ml', value: '7896012800713', image: './assets/img/spray-desembaracante/spray-desembaracante.png' },
        ]
      },
    ]
  },
};

const filtroFraldasData = [
  {
    sectionTitle: 'Linhas',
    sectionOptions: [
      {
        label: 'Todas',
        subsection: {
          sectionTitle: 'Tamanhos',
          sectionOptions: [
            {
              label: 'Todos',
              eans: [ '7896012878439', '7896012877456', '7896012878446', '7896012800416', '7896012800744', '7896012878453', '7896012800423', '7896012800751', '7896012878460', '7896012800430', '7896012800768', '7896012878477', '7896012800447', '7896012800782', '7896012877586', '7896012877913', '7896012877920', '7896012877975', '7896012877937', '7896012877982', '7896012877944', '7896012877999', '7896012877951', '7896012877869' ],
            },
            {
              label: 'P',
              eans: [ '7896012878439', '7896012877456', '7896012877913', '7896012877869' ]
            },
            {
              label: 'M',
              eans: [ '7896012878446', '7896012800416', '7896012800744', '7896012877920', '7896012877975' ]
            },
            {
              label: 'G',
              eans: [ '7896012878453', '7896012800423', '7896012800751', '7896012877937', '7896012877982' ]
            },
            {
              label: 'XG',
              eans: [ '7896012878460', '7896012800430', '7896012800768', '7896012877944', '7896012877999' ]
            },
            {
              label: 'SXG',
              eans: [ '7896012878477', '7896012800447', '7896012800782', '7896012877951' ]
            },
            {
              label: 'Grandinhos',
              eans: [ '7896012877586' ]
            },
          ]
        },
      },
      {
        label: 'Protek Proteção de Mãe',
        subsection: {
          sectionTitle: 'Tamanhos',
          sectionOptions: [
            {
              label: 'Todos',
              eans: [ '7896012878439', '7896012877456', '7896012878446', '7896012800416', '7896012800744', '7896012878453', '7896012800423', '7896012800751', '7896012878460', '7896012800430', '7896012800768', '7896012878477', '7896012800447', '7896012800782', '7896012877586' ]
            },
            {
              label: 'P',
              eans: [ '7896012878439', '7896012877456' ]
            },
            {
              label: 'M',
              eans: [ '7896012878446', '7896012800416', '7896012800744' ]
            },
            {
              label: 'G',
              eans: [ '7896012878453', '7896012800423', '7896012800751' ]
            },
            {
              label: 'XG',
              eans: [ '7896012878460', '7896012800430', '7896012800768' ]
            },
            {
              label: 'SXG',
              eans: [ '7896012878477', '7896012800447', '7896012800782' ]
            },
            {
              label: 'Grandinhos',
              eans: [ '7896012877586' ]
            },
          ]
        },
      },
      {
        label: 'Colo de Mãe',
        subsection: {
          sectionTitle: 'Tamanhos',
          sectionOptions: [
            {
              label: 'Todos',
              eans: [ '7896012877913', '7896012877920', '7896012877975', '7896012877937', '7896012877982', '7896012877944', '7896012877999', '7896012877951' ]
            },
            {
              label: 'P',
              eans: [ '7896012877913' ]
            },
            {
              label: 'M',
              eans: [ '7896012877920', '7896012877975' ]
            },
            {
              label: 'G',
              eans: [ '7896012877937', '7896012877982' ]
            },
            {
              label: 'XG',
              eans: [ '7896012877944', '7896012877999' ]
            },
            {
              label: 'SXG',
              eans: [ '7896012877951' ]
            },
          ]
        },
      },
      {
        label: 'Amor de Mãe',
        subsection: {
          sectionTitle: 'Tamanhos',
          sectionOptions: [
            {
              label: 'Tamanho Único',
              eans: [ '7896012877869' ]
            },
          ]
        },
      },
    ]
  },
];

const filtroOutrosData = [
  {
    sectionTitle: 'Linhas',
    sectionOptions: [
      {
        label: 'Todas',
        subsection: {
          sectionTitle: 'Fragrâncias',
          sectionOptions: [
            {
              label: 'Todas',
              eans: [
                '7896012877562',
                '7896012802410',
                '7896012878019',
                '7896012877739',
                '7896012800874',
                '7896012800850',
                '7896094905658',
                '7896094905627',
                '7896094905634',
                '7896094905665',
                '7896094905641',
                '7896012877722',
                '7896012800669',
                '7896012877715',
                '7896012800706',
                '7896012800867',
                '7896012800713',
              ],
            },
            {
              label: 'Suave',
              eans: [
                '7896012802410',
                '7896012878019',
                '7896012877722',
                '7896012877715',
              ]
            },
            {
              label: 'Camomila',
              eans: [
                '7896012877562',
                '7896094905658',
                '7896012800669',
                '7896012800706',
              ]
            },
          ]
        },
      },
      {
        label: 'Toalhas Umedecidas',
        subsection: {
          sectionTitle: 'Fragrâncias',
          sectionOptions: [
            {
              label: 'Todas',
              eans: [
                '7896012877562',
                '7896012802410',
                '7896012878019',
              ]
            },
            {
              label: 'Suave',
              eans: [
                '7896012802410',
                '7896012878019',
              ]
            },
            {
              label: 'Camomila',
              eans: [
                '7896012877562',
              ]
            },
          ]
        },
      },
      {
        label: 'Creme para Prevenção de Assaduras',
        subsection: {
          sectionTitle: 'Tamanhos',
          sectionOptions: [
            {
              label: '200ml',
              eans: [
                '7896012877739'
              ]
            },
          ]
        },
      },
      {
        label: 'Talco',
        subsection: {
          sectionTitle: 'Tamanhos',
          sectionOptions: [
            {
              label: '200ml',
              eans: [
                '7896012800874'
              ]
            },
          ]
        },
      },
      {
        label: 'Sabonete Espuma',
        subsection: {
          sectionTitle: 'Tamanhos',
          sectionOptions: [
            {
              label: '200ml',
              eans: [
                '7896012800850'
              ]
            },
          ]
        },
      },
      {
        label: 'Sabonete Barras',
        subsection: {
          sectionTitle: 'Fragrâncias',
          sectionOptions: [
            {
              label: 'Todas',
              eans: [
                '7896094905658',
                '7896094905627',
                '7896094905634',
                '7896094905665',
                '7896094905641',
              ]
            },
            {
              label: 'Camomila e Erva Cidreira - 80g',
              eans: [ '7896094905658' ]
            },
            {
              label: 'Glicerinado - 80g',
              eans: [ '7896094905627' ]
            },
            {
              label: 'Hidratante - 80g',
              eans: [ '7896094905634' ]
            },
            {
              label: 'Leite e Mel - 80g',
              eans: [ '7896094905665' ]
            },
            {
              label: 'Óleo de Amêndoas - 80g',
              eans: [ '7896094905641' ]
            },
          ]
        },
      },
      {
        label: 'Shampoo',
        subsection: {
          sectionTitle: 'Fragrâncias',
          sectionOptions: [
            {
              label: 'Todas',
              eans: [
                '7896012877722',
                '7896012800669',
              ]
            },
            {
              label: 'Suave - 200ml',
              eans: [
                '7896012877722',
              ]
            },
            {
              label: 'Camomila - 200ml',
              eans: [
                '7896012800669',
              ]
            },
          ]
        },
      },
      {
        label: 'Condicionador',
        subsection: {
          sectionTitle: 'Fragrâncias',
          sectionOptions: [
            {
              label: 'Todas',
              eans: [
                '7896012877715',
                '7896012800706',
              ]
            },
            {
              label: 'Suave - 200ml',
              eans: [
                '7896012877715',
              ]
            },
            {
              label: 'Camomila - 200ml',
              eans: [
                '7896012800706',
              ]
            },
          ]
        },
      },
      {
        label: 'Água de Colônia',
        subsection: {
          sectionTitle: 'Tamanhos',
          sectionOptions: [
            {
              label: '100ml',
              eans: [
                '7896012800867'
              ]
            },
          ]
        },
      },
      {
        label: 'Spray Desembaraçante',
        subsection: {
          sectionTitle: 'Tamanhos',
          sectionOptions: [
            {
              label: '200ml',
              eans: [
                '7896012800713'
              ]
            },
          ]
        },
      },
    ]
  },
];

function getProductByEan(ean) {
  return productsByEan[ean];
}







// const prodFraldas = [
//   {
//     slug: 'protecao-de-mae',
//     name: 'Proteção de Mãe',
//     modalData: modalData['protecao-de-mae'],
//   },
//   {
//     slug: 'colo-de-mae',
//     name: 'Colo de Mãe',
//     modalData: modalData['colo-de-mae'],
//   },
//   {
//     slug: 'amor-de-mae',
//     name: 'Amor de Mãe',
//     modalData: modalData['amor-de-mae'],
//   },
// ];

// const prodOutros = [
  
// ];










//////////////////////////////////////////////////////////////////////////////////////
// API - inicio
const API = (function() {
  let self = {};
  let apiToken = null;
  let refreshMinutes = 3.5; // Minutos para a próxima chamada de self.refreshToken
  let axiosCancelSource = null;

  /**
   * Gera um novo token antes que o mesmo expire
   */
  self.refreshToken = function() {
    axios.post('https://locatestore.intellibrand.ai/auth', {
      email: 'ontex@era-br.com',
      password: 'X1rdd1',
    }).then(response => {
      if(response.status !== 200 || !response.data || !response.data.token) {
        console.log('ModalCompra.js - refreshToken Axios Unexpected: ', response);
        return;
      }
      apiToken = response.data.token;
    }).catch(error => {
      console.log('ModalCompra.js - refreshToken Axios Error: ', error);
      apiToken = null;
    });
    setTimeout(() => self.refreshToken(), refreshMinutes * 60 * 1000);
  };

  /**
   * Procura um produto na API através do seu código EAN
   * 
   * @param {string} ean Código do produto
   */
  self.searchEan = function(ean, limit) {
    return new Promise((resolve, reject) => {
      try {
        if(axiosCancelSource) {
          axiosCancelSource.cancel('new');
        }
      } catch(e) {}

      axiosCancelSource = axios.CancelToken.source();

      axios.get(API_EAN_URL.replace(':ean', ean).replace(':limit', limit || 25), {
        headers: {
          Authorization: apiToken
        },
        cancelToken: axiosCancelSource.token,
      }).then(response => {
        // console.log('RESPONSE IF: ', response.data);
        if(response.data && response.data.data && Array.isArray(response.data.data.offers)) {
          let parsedOffers = [];
          response.data.data.offers.forEach(offer => {
            let currOffer = JSON.parse(JSON.stringify(offer));
            currOffer.ean = ean;
            currOffer.product = getProductByEan(ean);
            parsedOffers.push(currOffer);
          });
          console.log('Intellibrand.js - searchEan: ', response.data, parsedOffers);
          return resolve({data: { offers: parsedOffers }});
        } else {
          return resolve(response.data);
        }
      }).catch(error => {
        if(axios.isCancel(error)) {
          // console.log('Cancel');
          return;
        }
        return reject(error);
      });
    });
  };

  /**
   * Procura vários produtos na API e os ordena por preço
   * 
   * @param {Array} eans Array de códigos de produto
   */
  self.searchMultipleEans = async function(eans) {
    // let promiseCount = eans.length;
    // let promisesResolved = 0;
    // let resolveNext = function resolveNext() {
    //   promisesResolved++;
    //   if(promisesResolved > promiseCount) {
    //     resolve();
    //   }
    // };
    let allOffers = [];
    for(let i=0; i<eans.length; i++) {
      try {
        let eanResponse = await self.searchEan(eans[i], parseInt(50/eans.length));
        console.log('EAN - RESPONSE - TEST: ', eanResponse);
        if(eanResponse && eanResponse.data && eanResponse.data.offers) {
          for(let o=0; o<eanResponse.data.offers.length; o++) {
            if(eanResponse.data.offers[o].price) {
              allOffers.push(eanResponse.data.offers[o]);
            }
          }
        }
      } catch(e) {
        console.log('Error searching ean='+eans[i]+' --- ', e);
      }
    }

    // Ordenar por preço em ordem crescente
    allOffers.sort(function(a, b) {
      return a.price > b.price ? 1 : a.price < b.price ? -1 : 0;
    });

    allOffers = allOffers.slice(0, 24);

    return { data: { offers: allOffers } };
  };

  return self;
}());
// Refresh API token
API.refreshToken();
// API - fim
//////////////////////////////////////////////////////////////////////////////////////














export default {
  modalData,
  filtroFraldasData,
  filtroOutrosData,
  // prodFraldas,
  // prodOutros,
  API,
};
